/** Shared axis/tooltip helpers — each point = one scan session timestamp. */

export const axisTick = { fontSize: 11, fill: '#4E5155' };

/** Compact tick for dense X axis: "2026-07-13 14:00:00" → "14:00" */
export const formatAxisTime = (time) => {
  if (time == null) return '';
  const str = String(time);
  const clock = str.includes(' ') ? str.split(' ')[1] : str;
  return clock.slice(0, 5);
};

export const chartMargin = {
  top: 24,
  right: 16,
  left: 12,
  bottom: 8,
};

export const tickEvery = (length) => Math.max(0, Math.floor(length / 10) - 1);
